import Client from "./clients/rest";


export default {

    getDeliveryAreas(businessId,timingId) {
        return Client.get(`business/${businessId}/delivery_areas?timingId=${timingId}`);
    },

    upsertDeliveryArea(businessId,body) {
        return Client.post(`business/${businessId}/delivery_areas_update`,
           body
          );
    },

    deleteItemDeliveryArea(businessId,id) {
        return Client.post(`business/${businessId}/delivery_area_delete_item?id=${id}`);
    },

    deliveryAreaAddItem(businessId,body) {
        return Client.post(`business/${businessId}/delivery_areas_insert_item`,body);
    },

    upsertDeliveryAreaMulti(businessId,body) {
        return Client.post(`business/${businessId}/delivery_areas_update_multi`,
           body
          );
    },

    insertOrUpdateTiming(businessId,body) {
        return Client.post(`business/${businessId}/InsertOrUpdateTiming`,
        body
       );
    },

    getTiming(businessId, timingId){
        return Client.get(`business/${businessId}/get_timing?timingId=${timingId}`);
    }

};
